import { CellStyle } from 'ag-grid-community';

export const globalAGGridCellStyle: CellStyle = {
  borderColor: 'transparent',
  color: '#44546a',
};
